import script from "./software.vue?vue&type=script&setup=true&lang=js"
export * from "./software.vue?vue&type=script&setup=true&lang=js"

import "./software.vue?vue&type=style&index=0&id=4a292a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a292a06"]])

export default __exports__